module.exports = __webpack_public_path__ + "static/img/13.5a482d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/13.png
// module id = azX6
// module chunks = 0